<section class="healthcare-workflow section-padding">
    <div class="container">

        <div class="row justify-content-center text-center">
            <div class="col-lg-9">

                <span class="section-badge">
                    {{ 'healthcareWorkflow.eyebrow' | translate }}
                </span>

                <h2 class="section-title">
                    {{ 'healthcareWorkflow.title' | translate }}
                </h2>

                <p class="section-subtitle">
                    {{ 'healthcareWorkflow.subtitle' | translate }}
                </p>

            </div>
        </div>

        <div class="row g-4 mt-4">

            <div class="col-md-4">
                <div class="healthcare-workflow-card h-100">

                    <div class="healthcare-workflow-icon">
                        <i class="fas fa-calendar-check" aria-hidden="true"></i>
                    </div>

                    <span class="healthcare-workflow-step">
                        {{ 'healthcareWorkflow.step1Label' | translate }}
                    </span>

                    <h3>
                        {{ 'healthcareWorkflow.step1Title' | translate }}
                    </h3>

                    <p>
                        {{ 'healthcareWorkflow.step1Text' | translate }}
                    </p>

                </div>
            </div>

            <div class="col-md-4">
                <div class="healthcare-workflow-card h-100">

                    <div class="healthcare-workflow-icon">
                        <i class="fas fa-hospital" aria-hidden="true"></i>
                    </div>

                    <span class="healthcare-workflow-step">
                        {{ 'healthcareWorkflow.step2Label' | translate }}
                    </span>

                    <h3>
                        {{ 'healthcareWorkflow.step2Title' | translate }}
                    </h3>

                    <p>
                        {{ 'healthcareWorkflow.step2Text' | translate }}
                    </p>

                </div>
            </div>

            <div class="col-md-4">
                <div class="healthcare-workflow-card h-100">

                    <div class="healthcare-workflow-icon">
                        <i class="fas fa-user-nurse" aria-hidden="true"></i>
                    </div>

                    <span class="healthcare-workflow-step">
                        {{ 'healthcareWorkflow.step3Label' | translate }}
                    </span>

                    <h3>
                        {{ 'healthcareWorkflow.step3Title' | translate }}
                    </h3>

                    <p>
                        {{ 'healthcareWorkflow.step3Text' | translate }}
                    </p>

                </div>
            </div>

        </div>
    </div>
</section>